import { Group, Stack, Text } from '@mantine/core';

import type { LabeledValueViewProps } from './LabeledValue.types';

export function LabeledValueView({ label, value, align = 'vertical', truncate = false }: LabeledValueViewProps) {
  const valueNode =
    typeof value === 'string' ? (
      <Text size="sm" fw={500} truncate={truncate}>
        {value}
      </Text>
    ) : (
      value
    );

  const labelNode =
    typeof label === 'string' ? (
      <Text size="xs" c="dimmed">
        {label}
      </Text>
    ) : (
      label
    );

  if (align === 'horizontal') {
    return (
      <Group justify="space-between" gap="sm" wrap="nowrap">
        {labelNode}
        {valueNode}
      </Group>
    );
  }

  return (
    <Stack gap={2} style={{ minWidth: truncate ? 0 : undefined }}>
      {labelNode}
      {valueNode}
    </Stack>
  );
}
